/**
 * El mail del último ingreso en este dispositivo — el `last_email` de Android
 * (AppPreferences). Sobrevive al cierre de sesión a propósito: la pantalla de
 * ingreso de la PWA instalada lo trae puesto, y sólo falta la contraseña.
 */
const KEY = "forja.ultimo_email";

export function leerUltimoEmail(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function guardarUltimoEmail(email: string | null | undefined): void {
  if (!email) return;
  try {
    localStorage.setItem(KEY, email);
  } catch {
    // Sin storage, el campo arranca vacío: nada se rompe.
  }
}
